import {DataListModel} from "../interface";
import {RoomModel} from "./room.model";

export class RoomsModel extends DataListModel {
  items: RoomModel[] = [];
}
